"use client";

import { Button } from "@relume_io/relume-ui";
import React from "react";
import { RxChevronRight } from "react-icons/rx";
import ContactButton from '../../components/shared/ContactButton';
import Image from "../../assets/images/Cactus.png"

export function Defense() {
  return (
    <section id="relume" className="px-[5%] py-16 md:py-24 lg:py-28 bg-[#E5F0F1]">
      <div className="container md:max-w-5xl lg:max-w-7xl mx-auto">
        <div className="grid grid-cols-1 gap-y-12 md:grid-flow-row md:grid-cols-2 md:items-center md:gap-x-12 lg:gap-x-20">
        <div>
            <img
              src={Image}
              className="w-full h-150 object-cover rounded-xl"
              alt="Relume placeholder image"
            />
          </div>
          <div>
            <p className="mb-3 font-semibold md:mb-4">Verteidigung</p>
            <h1 className="text-4xl  leading-[1.2] md:text-[30px] lg:text-[30px] max-w-[450px]">
            Proaktive Lösungen zur Abwehr von Bedrohungen und zur Reaktion auf Zwischenfälle
            </h1>
            <p className="mb-6 md:mb-8 md:text-md">
            Unsere Threat Defense- und Incident Response-Dienste stellen sicher, dass Ihr
              Organisation auf jede Cyber-Bedrohung vorbereitet ist. Mit einem strukturierten
              Ansatz bieten wir schnelle und effektive Lösungen zur Minderung von
              Risiken.
            </p>
            <div className="grid grid-cols-1 gap-6 py-2 sm:grid-cols-2">
              <div>
                <h6 className="mb-3 text-md font-bold leading-[1.4] md:mb-4 md:text-xl">
                MDR-Prozess
                </h6>
                <p className="max-w-[250px]">
                Umfassende Managed Detection und Response zum Schutz Ihrer
                digitalen Werte rund um die Uhr.
                </p>
              </div>
              <div>
                <h6 className="mb-3 text-md font-bold leading-[1.4] md:mb-4 md:text-xl">
                Reaktion auf Zwischenfälle                </h6>
                <p className="max-w-[250px]">
                Schnelle Reaktion auf Zwischenfälle, um die Auswirkungen zu minimieren und den Betrieb effizient wiederherzustellen.
                </p>
              </div>
            </div>
            <div className="mt-6 flex flex-wrap items-center gap-4 md:mt-8">
             
           
                <ContactButton/>
              
             
            </div>
          </div>
         
        </div>
      </div>
    </section>
  );
}
